export default __webpack_public_path__ + "static/media/imgComp1.6af780ce.webp";